import axios from "axios";

const baseURL = 'https://datacenter.gamebrain.io/api/'
// const baseURL = 'http://localhost:82/api/'

const fetchInstance = axios.create({
  baseURL:baseURL
})

// request拦截器
fetchInstance.interceptors.request.use(config => {
  // if (document.location.origin!=='http://beta.gamebrain.io'){
  //   config.baseURL = "https://datacenter.gamebrain.io/api/"
  // }
  config.data.user_id = localStorage.getItem('user_id')
  config.data.user_token = localStorage.getItem('user_token')
  return config
}, error => {
  return Promise.reject(error)
})

// response拦截器
fetchInstance.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code===4000){
      window.location = '/'
    }
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default fetchInstance



// WEBPACK FOOTER //
// ./src/api/api.js